import React, {useEffect, useState} from "react"
import {FadeInAnimation} from "@next/animations"
import Cookies from "js-cookie"
import connect from "./connect"
import {CLOSE_ICON_URL, COOKIE_VALUE} from "../../config/constants"
import {formatCdnPath} from "../../utils/getCdnUrl"
import {doCookiePolicy} from "../../utils/featureSwitch"
import {Container, StyledTitle, UnstyledButton, Header, BodyText} from "./component"
import {PublishCookiePolicyClose, PublishCookiePolicyOpen, PublishCookiePolicyRedirect} from "../../events"

const EXPIRATION_DAYS = 365

export type CookieConsentProps = {
    cookieDomain: string
    hasConsentCookie: boolean
    privacyUrl: string
    cookieName: string
    text: any
}

export const CookieConsent = ({cookieDomain, hasConsentCookie, privacyUrl, cookieName, text}: CookieConsentProps) => {
    const [showPopUp, setShowPopUp] = useState(false)
    const {title, body, link, linkText, closeIconAltText} = text

    const onClose = () => {
        setShowPopUp(false)
        PublishCookiePolicyClose()
    }

    const onLinkClick = () => {
        PublishCookiePolicyRedirect()
        window.location.href = privacyUrl
    }

    useEffect(() => {
        if (doCookiePolicy() && !hasConsentCookie) {
            Cookies.set(cookieName, COOKIE_VALUE, {expires: EXPIRATION_DAYS, domain: cookieDomain})
            setShowPopUp(true)
            PublishCookiePolicyOpen()
        }
    }, [hasConsentCookie, cookieName, cookieDomain])

    return (
        <FadeInAnimation show={showPopUp} timeout={300}>
            <Container id="cookie-consent" data-testid="header-cookie-consent">
                <Header>
                    <StyledTitle variant="h5">{title}</StyledTitle>
                    <UnstyledButton onClick={onClose}>
                        <img
                            data-testid="header-cookie-consent-close"
                            src={`${formatCdnPath(CLOSE_ICON_URL)}`}
                            alt={closeIconAltText}
                        />
                    </UnstyledButton>
                </Header>
                <div>
                    <BodyText>{body}&nbsp;</BodyText>
                    <BodyText>
                        <UnstyledButton data-testid="header-cookie-consent-privacy-link" onClick={onLinkClick}>
                            {link}
                        </UnstyledButton>
                        &nbsp;{linkText}
                    </BodyText>
                </div>
            </Container>
        </FadeInAnimation>
    )
}

export default connect(CookieConsent)
